
const IMPERMAX_WEBSITE_LINK = 'https://impermax.finance';
const IMPERMAX_TWITTER_LINK = 'https://twitter.com/ImpermaxFinance';
const IMPERMAX_TELEGRAM_LINK = 'https://t.me/ImpermaxFinance';
const IMPERMAX_DISCORD_LINK = 'https://discord.gg/XN739EgG4X';
const IMPERMAX_MEDIUM_LINK = 'https://impermax.medium.com';
const IMPERMAX_REDDIT_LINK = 'https://www.reddit.com/r/ImpermaxFinance';
const IMPERMAX_GIT_HUB_LINK = 'https://github.com/Impermax-Finance';
const IMPERMAX_YOU_TUBE_LINK = 'https://www.youtube.com/channel/UCTPuBCAHAnE6a8hcBon48QA';

export {
  IMPERMAX_TELEGRAM_LINK,
  IMPERMAX_TWITTER_LINK,
  IMPERMAX_WEBSITE_LINK,
  IMPERMAX_REDDIT_LINK,
  IMPERMAX_DISCORD_LINK,
  IMPERMAX_YOU_TUBE_LINK,
  IMPERMAX_MEDIUM_LINK,
  IMPERMAX_GIT_HUB_LINK
};
